module.exports = __webpack_public_path__ + "static/img/4.86bb77e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-hogar/4.png
// module id = edNf
// module chunks = 0